import { Component, OnInit, OnDestroy } from '@angular/core';
import { DeliveriesService } from 'src/app/services/deliveries.service';
import { MatDialog, MatSnackBar } from '@angular/material';
import { DialogDeliveryStatusComponent } from 'src/app/components/dialogs/dialog-delivery-status/dialog-delivery-status.component';
import { Subscription } from 'rxjs';
import { DialogDeliveryDateComponent } from 'src/app/components/dialogs/dialog-delivery-date/dialog-delivery-date.component';
import { MetaService } from 'src/app/services/meta.service';

import * as moment from 'moment';
import { DialogAddOrderPaymentComponent } from 'src/app/components/dialogs/dialog-add-order-payment/dialog-add-order-payment.component';

@Component({
  selector: 'app-deliveries-table',
  templateUrl: './deliveries-table.component.html',
  styleUrls: ['./deliveries-table.component.css'],
  host: { '(document:keypress)': 'handleKeyboardEvent($event)' }
})
export class DeliveriesTableComponent implements OnInit, OnDestroy {

  harvests = '';
  revenue = '';
  deliveries = [];
  deliveriesSub: Subscription;
  panelOpenState: boolean = false;
  queryMismatch = false;
  isLoading = false;
  isDownloading = false;

  data = {
    startDate: '',
    endDate: ''
  }

  public search = {
    startDate: '',
    endDate: '',
    status: '',
    mobile: '',
    userName: '',
    userMobile: ''
  }

  constructor(private deliveriesService: DeliveriesService, private dialog: MatDialog, private snackBar: MatSnackBar, private meta: MetaService) { }

  ngOnInit() {
    this.isLoading = true;
    this.meta.getMetaData().subscribe(result => {
      if (result.success) {
        this.data.startDate = result.data.query_dates.START_DATE;
        this.data.endDate = result.data.query_dates.END_DATE;

        const data = new FormData();
        data.append('startDate', this.data.startDate);
        data.append('endDate', this.data.endDate)

        this.deliveriesService.getDeliveries(data).subscribe(result => {
          this.isLoading = false;
          this.deliveries = result.data.deliveries;
          this.harvests = result.data.harvests;
          this.revenue = result.data.revenue;
        }, error => {
          this.isLoading = false;
          this.queryMismatch = true;
          this.snackBar.open(error.error.data, 'Dismiss', {
            duration: 3000
          });
        });
      }
    });

    this.deliveriesSub = this.deliveriesService.getDeliveriesSub().subscribe(result => {
      this.deliveries = result;
    })
  }

  togglePanel() {
    this.panelOpenState = !this.panelOpenState
  }

  onSearch() {
    this.isLoading = true;

    const data = new FormData();

    if (this.search.startDate == '') {
      data.append('startDate', this.data.startDate.toString());
    }

    if (this.search.endDate == '') {
      data.append('endDate', this.data.endDate.toString());
    }

    if (this.search.startDate !== '') {
      data.append('startDate', moment(this.search.startDate).format('DD-MM-YYYY').toString());
    }

    if (this.search.endDate !== '') {
      data.append('endDate', moment(this.search.endDate).format('DD-MM-YYYY').toString());
    }

    if (this.search.status == '' || this.search.status == 'none') {
      data.delete('status');
    } else {
      data.append('status', this.search.status);
    }

    if (this.search.mobile == '') {
      data.delete('mobile');
    } else {
      data.append('mobile', this.search.mobile);
    }

    if (this.search.userMobile == '') {
      data.delete('userMobile');
    } else {
      data.append('userMobile', this.search.userMobile);
    }

    if (this.search.userName == '') {
      data.delete('userName');
    } else {
      data.append('userName', this.search.userName);
    }

    this.deliveriesService.getDeliveries(data).subscribe(result => {
      this.queryMismatch = false
      this.isLoading = false;
      this.deliveries = result.data.deliveries;
      this.harvests = result.data.harvests;
      this.revenue = result.data.revenue;
    }, error => {
      this.queryMismatch = true;
      this.isLoading = false;
      this.snackBar.open(error.error.data, 'Dismiss', {
        duration: 3000
      });
    });
  }

  onUpdate(ID: string, status: string, undo: boolean) {

    let message: string;
    let statusUpdate: string;

    if (!undo && status === 'Processing') {
      message = 'processing';
      statusUpdate = 'Processing';
    } else if (!undo && status === 'Completed') {
      message = 'completed';
      statusUpdate = 'Completed';
    } else if (undo && status === 'Completed') {
      message = 'processing';
      statusUpdate = 'Processing';
    } else if (undo && status === 'Processing') {
      message = 'pending';
      statusUpdate = 'Pending';
    }

    this.dialog.open(DialogDeliveryStatusComponent, {
      data: {
        _id: ID,
        message: message,
        status: statusUpdate,
        filter: this.search
      }
    });
  }

  onAlterDate(ID: string, date: string) {
    this.dialog.open(DialogDeliveryDateComponent, {
      data: {
        _id: ID,
        deliveryDate: date,
        filter: this.search
      }
    });
  }

  onAddPayment(ID) {
    this.dialog.open(DialogAddOrderPaymentComponent, {
      data: {
        _id: ID,
        filter: this.search
      }
    });
  }

  onDownload() {

    this.isDownloading = true;

    const data = new FormData();

    if (this.search.startDate == '') {
      data.append('startDate', this.data.startDate.toString());
    }

    if (this.search.endDate == '') {
      data.append('endDate', this.data.endDate.toString());
    }

    if (this.search.startDate !== '') {
      data.append('startDate', moment(this.search.startDate).format('DD-MM-YYYY').toString());
    }

    if (this.search.endDate !== '') {
      data.append('endDate', moment(this.search.endDate).format('DD-MM-YYYY').toString());
    }

    if (this.search.status == '' || this.search.status == 'none') {
      data.delete('status');
    } else {
      data.append('status', this.search.status);
    }

    if (this.search.mobile == '') {
      data.delete('mobile');
    } else {
      data.append('mobile', this.search.mobile);
    }

    if (this.search.userMobile == '') {
      data.delete('userMobile');
    } else {
      data.append('userMobile', this.search.userMobile);
    }

    if (this.search.userName == '') {
      data.delete('userName');
    } else {
      data.append('userName', this.search.userName);
    }

    this.deliveriesService.downloadDocument(data).subscribe(result => {
      this.isDownloading = false;
      if (result.success) {
        window.open(result.data);
      }
    }, error => {
      this.isDownloading = false;
      this.snackBar.open(error.error.data, 'Dismiss', {
        duration: 3000
      });
    });
  }

  onClear() {
    this.search = {
      startDate: '',
      endDate: '',
      status: '',
      mobile: '',
      userName: '',
      userMobile: ''
    }

    const data = new FormData();

    data.append('startDate', this.data.startDate.toString());
    data.append('endDate', this.data.endDate.toString());

    this.deliveriesService.getDeliveries(data).subscribe(result => {
      this.queryMismatch = false
      this.isLoading = false;
      this.deliveries = result.data.deliveries;
      this.harvests = result.data.harvests;
      this.revenue = result.data.revenue;
    }, error => {
      this.queryMismatch = true;
      this.isLoading = false;
      this.snackBar.open(error.error.data, 'Dismiss', {
        duration: 3000
      });
    });
  }

  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.key == 'Enter' && event.shiftKey == false) {
      this.onSearch();
    } else if (event.key == 'Enter' && event.shiftKey == true) {
      this.onClear();
    }
  }

  ngOnDestroy() {
    this.deliveriesSub.unsubscribe();
  }
}
